import { Directive, ElementRef } from '@angular/core';
import { LayoutEditorService } from '../layout-editor/layout-editor.service';
import { ThemeEditorStoreService } from '../theme-editor/theme-editor-store.service';

@Directive({
  selector: '[kvePreviewThemeBg]'
})
export class PreviewThemeBgDirective {

  constructor(
    private layoutEditorService:LayoutEditorService,
    private themeEditorStoreService:ThemeEditorStoreService,
    private el:ElementRef) { }

  ngAfterViewInit():void{
    /* this.layoutEditorService.getPallette().subscribe(palette => {
      if(palette != null && palette != undefined){
        this.setPreviewTheme(palette);
      }
    }) */
    this.themeEditorStoreService.state$.subscribe(themeConfig => {
      let themePostfix = themeConfig.themeConfigState.name?themeConfig.themeConfigState.name:"default";
      //this.kveThemeClass = themeConfig.themeConfigState.name;
      this.setPreviewTheme(themePostfix);
      //let previewHostEl:HTMLElement = this.previewHost.elementRef.nativeElement;
      //previewHostEl.classList.add("nb-theme-"+this.kveThemeClass)
    })
  }

  setPreviewTheme(themePostfix:string){
    const host = <HTMLElement>this.el.nativeElement
    host.classList.add('nb-theme-'+themePostfix);
    const styles = getComputedStyle(host);
    console.log(styles.getPropertyValue('--layout-background-color'))
    host.style.setProperty('background',styles.getPropertyValue('--layout-background-color'))
    //this.iframeBody.classList.add('nb-theme-'+themePostfix);
  }
}
